import { z } from 'zod'

export const FIELD_TYPES = [
  'signature',
  'initials',
  'date_signed',
  'date',
  'text',
  'checkbox',
  'radio',
  'dropdown',
] as const

export const fieldTypeSchema = z.enum(FIELD_TYPES)

export type FieldType = z.infer<typeof fieldTypeSchema>

export const REQUIRED_BY_DEFAULT_FIELD_TYPES = [
  'signature',
  'initials',
  'date_signed',
] as const satisfies readonly FieldType[]

export const PRISMA_FIELD_TYPES = [
  'SIGNATURE',
  'INITIALS',
  'DATE_SIGNED',
  'DATE',
  'TEXT',
  'CHECKBOX',
  'RADIO',
  'DROPDOWN',
] as const

export type PrismaFieldType = (typeof PRISMA_FIELD_TYPES)[number]

export const FIELD_TYPE_TO_PRISMA = {
  signature: 'SIGNATURE',
  initials: 'INITIALS',
  date_signed: 'DATE_SIGNED',
  date: 'DATE',
  text: 'TEXT',
  checkbox: 'CHECKBOX',
  radio: 'RADIO',
  dropdown: 'DROPDOWN',
} as const satisfies Record<FieldType, PrismaFieldType>

export const FIELD_TYPE_FROM_PRISMA = {
  SIGNATURE: 'signature',
  INITIALS: 'initials',
  DATE_SIGNED: 'date_signed',
  DATE: 'date',
  TEXT: 'text',
  CHECKBOX: 'checkbox',
  RADIO: 'radio',
  DROPDOWN: 'dropdown',
} as const satisfies Record<PrismaFieldType, FieldType>
